import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-serverinfo',
  templateUrl: './serverinfo.component.html',
  styleUrls: ['./serverinfo.component.css']
})
export class ServerinfoComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
